import { useMutation } from '@tanstack/react-query';

import { UnlogVoucherPayload, UnlogVoucherResponse, unlogVoucher } from '~/services/PromoService';

export function useUnlogVoucher() {
  return useMutation<UnlogVoucherResponse, Error, UnlogVoucherPayload>({
    mutationFn: async (payload) => unlogVoucher(payload),
  });
}
